import { ref } from "vue";
import ResponseService from "@/_services/response.service";

const result = ref({ Success: false, Data: null });
const routePrefix = ref("products/");

const popup_list = async (tig) => {

    const { get, responseResult } = ResponseService();

    await get(routePrefix.value + "popup-list?tig="+tig);

    if (responseResult.value) {
        if (responseResult.value.Messages.filter(x => x.MessageId == 1).length > 0) {
            result.value.Success = true;
            result.value.Data = responseResult.value.Data;
        }
        else 
            result.value.Success = false;
    }
}


const ProductService = () => {
    return { popup_list, result }
}

export default ProductService